'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RUB = exports.RUB = 643;
var EUR = exports.EUR = 978;
var USD = exports.USD = 840;
var GBP = exports.GBP = 826;
var UAH = exports.UAH = 980;
var MDL = exports.MDL = 498;
var BYN = exports.BYN = 933;
var TRY = exports.TRY = 949;
var AED = exports.AED = 784;
var SGD = exports.SGD = 702;


//////////////////
// WEBPACK FOOTER
// ./src/components/AmountFormat/constants.js
// module id = 1600
// module chunks = 0